import LoginForm from "../components/login/LoginForm";

// Wrapp for the login form
const Login = () => {
  return <LoginForm />;
};
export default Login;
